import sidebar from '@/config/sidebars/admin_hubspot'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminHubspotProducts = {
  index: async(props) => {
    const { default: ProductsIndex } = await import('@/vue_widgets/admin/hubspot/products/index.vue')
    createVueApp(ProductsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: ProductsShow } = await import('@/vue_widgets/admin/hubspot/products/show.vue')
    createVueApp(ProductsShow, { props, sidebar })
  }
}
